/**
 * random.ts
 * Utilitários de geração de números aleatórios seguros (CSPRNG)
 * Baseado em crypto.getRandomValues
 */

/**
 * Gera um inteiro aleatório seguro no intervalo [0, maxExclusive)
 * Substitui: Math.floor(Math.random() * max)
 */
export function secureRandomIndex(maxExclusive: number): number {
    if (!Number.isInteger(maxExclusive) || maxExclusive <= 0) {
        throw new Error("maxExclusive must be a positive integer");
    }

    const buffer: Uint32Array = new Uint32Array(1);
    const limit: number = Math.floor(0xFFFFFFFF / maxExclusive) * maxExclusive;

    let value: number;
    do {
        crypto.getRandomValues(buffer);
        value = buffer[0];
    } while (value >= limit);

    return value % maxExclusive;
}

/**
 * Gera uma placa aleatória para testes.
 * ATENÇÃO: método apenas para ambiente de teste.
 * Em produção, a placa deve vir do sistema real.
 *
 * Formato: ABC-1234
 * Primeira letra nunca será 'Z'
 */
export function generateRandomPlate(): string {
    const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const lettersNoZ = "ABCDEFGHIJKLMNOPQRSTUVWXY"; // sem Z
    const numbers = "0123456789";

    let plate = "";

    // Primeira letra (sem Z)
    plate += lettersNoZ.charAt(
        secureRandomIndex(lettersNoZ.length)
    );

    // Mais 2 letras (podem incluir Z)
    for (let i = 0; i < 2; i++) {
        plate += letters.charAt(
            secureRandomIndex(letters.length)
        );
    }

    plate += "-";

    // 4 números
    for (let i = 0; i < 4; i++) {
        plate += numbers.charAt(
            secureRandomIndex(numbers.length)
        );
    }

    return plate;
}